import React, { Component } from "react";
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import Button from '../Button/index';
import Inputs from '../Inputs/index';
import LocationIcon from '../../images/icons/location.svg'

import { searchActivities,setSearchValue } from '../../actions/findActivities/search/get';


class SearchBar extends Component
{
    constructor(props) {
        super(props);

        this.state = {
            activity: this.props.searchValues.activity || '',
            address: this.props.searchValues.address || '', // bh1 1jn
            radius: this.props.searchValues.radius || '', // 100
            latitude: this.props.searchValues.latitude || '',
            longitude: this.props.searchValues.longitude || '',
            radiusOptions: [{id: 1, value: 'Within 1 mile'},
                            {id: 5, value: 'Within 5 miles'},
                            {id: 10, value: 'Within 10 miles'},
                            {id: 25, value: 'Within 25 miles'},
                            {id: 50, value: 'Within 50 miles'}],
        }
    }
    componentDidMount() {
        this.props.setSearchValue('address', this.state.address);
        this.props.setSearchValue('radius', (this.state.radius || this.state.radiusOptions[1].id));
    }

    handleChange = (e) => {
        const target    = e.target;
        const name      = target.name;
        const value     = (name === 'radius' && !target.value.length) ? this.state.radiusOptions[1].id : target.value;

        this.setState({ [name]: value });
        this.props.setSearchValue(name, value);

        if (name === 'address' && value !== 'Your current location') {
            this.props.setSearchValue('latitude', '');
            this.props.setSearchValue('longitude', '');
        }
    };

    handleSearch = (e) => {
        e.preventDefault();
        this.props.setListCurrentPage(1);
        this.props.searchActivities(this.props.searchValues, this.props.selectedFilters, this.props.displayType === 'map');
    };

    handleGeolocation = (e) => {
        e.preventDefault();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(pos => {
                this.props.setSearchValue('latitude', `${pos.coords.latitude}`);
                this.props.setSearchValue('longitude', `${pos.coords.longitude}`);
                this.props.setSearchValue('address', 'Your current location');

                this.setState({
                    latitude : `${pos.coords.latitude}`,
                    longitude : `${pos.coords.longitude}`,
                    address: 'Your current location'
                })
            });
        } else {
            alert("No geolocation available");
        }
    }

    render() {
        const { selectedTab, showFilter, modalControllerClick } = this.props;

        return (
            <div className={['content-layout content-layout__wide content-layout_collapse search-container'].join(' ')}>
                <div className="large-wrap">
                    <form id="search-activity-form" onSubmit={this.handleSearch}>
                        <div className={['search-content', selectedTab === 0 ? 'three-cols': 'two-cols col-67-33'].join(' ')}>
                            {(selectedTab === 0) && <div className="col">
                                <Inputs
                                    type="text"
                                    label="What are you looking for?"
                                    placeholder="e.g. Walking, Cycling, Pharmacy"
                                    classes="text-input"
                                    onChange={this.handleChange}
                                    params={{ id: 'search-activity', name: 'activity', value: this.state.activity }}
                                />
                            </div>}
                            <div className="col">
                                <div className="form-field">
                                    <label className="flex"><span>Where are you looking?</span>
                                    <button type="button" className="button underline-button" onClick={this.handleGeolocation}>
                                        <span className="label-text">Get location</span>
                                    </button>
                                    </label>
                                    <div className="input-field with-icon">
                                        <Inputs
                                            type="text"
                                            placeholder="E.g. Wimborne, Dorchester, BH1 1PE"
                                            classes="text-input location-search-input"
                                            onChange={this.handleChange}
                                            params={{ id: 'search-location', name: 'address', value: this.state.address }}
                                        />
                                        {(selectedTab === 0) && <a className="location-icon" onClick={this.handleGeolocation}>
                                            <img src={LocationIcon} alt="activity image icon"/>
                                        </a>}
                                        {(selectedTab === 1) && <a className="location-icon-explore" onClick={this.handleGeolocation}>
                                            <img src={LocationIcon} alt="activity image icon"/>
                                        </a>}
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="two-cols">
                                    <div className="col">
                                        <MediaQuery minWidth={768}>
                                            {(matches) => (
                                                <Inputs
                                                    type="select"
                                                    label={!matches ? 'Select distance' : ''}
                                                    params={{ id: 'radius', name: 'radius', value: this.state.radius || this.state.radiusOptions[1].id, options: this.state.radiusOptions }}
                                                    onChange={this.handleChange}
                                                    label="Radius"
                                                />
                                            )}
                                        </MediaQuery>
                                    </div>
                                    <div className="col">
                                        <Button
                                            type="submit"
                                            label="search"
                                            classes="button-round button__secondary-green"
                                            id="search-activity-button"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    {showFilter && <MediaQuery maxWidth={767}>
                        <div className="modal-controller-container">
                            <button
                                className="underline-button modal-controller"
                                onClick={modalControllerClick}
                            >
                                Filter search results
                            </button>
                        </div>
                    </MediaQuery>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedFilters: state.selectedFilters,
    searchValues: state.searchValues,
    displayType: state.displayType,
});

const mapDispatchToProps = dispatch => ({
    searchActivities: (values, filters, limit) => {
        dispatch(searchActivities(values, filters, limit));
    },
    setSearchValue: (k,v) => {
        dispatch(setSearchValue(k,v));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);

